<template>
    <div class="back">
        <div id="foot">
            <!-- 网站地图 start-->
            <div class="web-map">
                <p class="mg-b-30 h5">网站地图</p>
                <ul>
                    <li>
                        <a class="white-link" href="#">潮合科技</a>
                    </li>
                    <li>
                        <a class="white-link" href="#">fswan财务软件系统</a>
                    </li>
                    <li>
                        <a class="white-link" target="_blank" @click="handleToggleTab(3)" >文档中心</a>
                    </li>
                    <li>
                        <a class="white-link" target="_blank" href="#">更新日志</a>
                    </li>
                </ul>
            </div>
            <!-- 网站地图 end-->

            <!-- 联系我们 start -->
            <div class="contact">
                <p class="mg-b-30 h5">联系方式</p>
                <ul>
                    <li><span>电话：</span><span>18976205160</span></li>
                    <li>
                        <span>地址：</span>
                        <span>海南省海口市高新区产业中心1号2#06室</span>
                    </li>
                    <li><span>微信：</span><span>chkj_666</span></li>
                    <li><span>邮箱：</span><span>chkj951@163.com</span></li>
                </ul>
            </div>
            <!-- 联系我们 end -->

            <!-- 帮助 start-->
            <div class="help">
                <p class="mg-b-30 h5">关于</p>
                <ul>
                    <li>
                        <a class="white-link" target="_blank" href="#">关于我们</a>
                    </li>
                    <li>
                        <a class="white-link" target="_blank" href="#">联系我们</a>
                    </li>
                    <li>
                        <a class="white-link" target="_blank" href="#">知识产权</a>
                    </li>
                    <li>
                        <a class="white-link" target="_blank" href="#">免责声明</a>
                    </li>
                </ul>
            </div>
            <!-- 帮助 end-->
        </div>
        <div class="statement-all">
            <!-- pc端展现 -->
            <a class="statement hidden white-link" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46010502000687" >
                <img src="../assets/img/batb.png" width="16" height="16" style="float:left;margin-top: 1px;margin-right: 2px;"/>
                琼公网安备 46010502000687号
            </a>
            <a class="statement hidden white-link" target="_blank" href="https://beian.miit.gov.cn/">琼ICP备2021001740号-2</a>
            <a class="statement hidden">Copyright © 2019 - 2035 SWAN All Rights Reserved 潮合科技版权所有</a>
            <!-- 移动端展现 -->
            <a class="statement none" target="_blank" href="https://beian.miit.gov.cn/">琼ICP备2021001740号-2</a>
            <a class="statement none" >Copyright © 2019 - 2035 FSWAN All Rights Reserved 潮合科技版权所有</a>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            handleToggleTab(id) {
                this.$emit('handleToggleTab', id);
            }
        }
    };
</script>